import axios from 'axios';
import Config from "../config/index";
import authHeader from "@/services/auth-header";

class AuthService {
    login(user) {
        return axios
            .post(Config.apiBasePath + '/user/login', {
                user_email: user.user_email,
                user_name: user.user_name,
                password: user.password
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    register(user) {
        return axios.post(Config.apiBasePath + '/user/register', user);
    }

    getUserDataByToken(token) {
        return axios.get(Config.apiBasePath + '/user/info', {
            headers: {Authorization: 'Bearer ' + token}
        }).then(d => {
            localStorage.setItem('user', JSON.stringify(d.data));
            return d.data;
        });
    }

    ping() {
        return axios.get(Config.apiBasePath + '/ping', {headers: authHeader()})
    }

    verifyOAuth2Callback(data, provider = 'keycloak') {
        return axios.get(Config.apiBasePath + '/oauth2/login/code/' + provider, {
            params: data,
        });
    }
}

export default new AuthService();